import { render } from "./MoreNews.vue?vue&type=template&id=1449c6d1&scoped=true"
import script from "./MoreNews.vue?vue&type=script&lang=js"
export * from "./MoreNews.vue?vue&type=script&lang=js"

import "./MoreNews.vue?vue&type=style&index=0&id=1449c6d1&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1449c6d1"]])

export default __exports__